import React, { useContext, useEffect, useState } from "react";
import { Box } from "@mui/material";
import axios from "axios";
import { AuthContext } from "../contexts/AuthContext";
import ManageUsers from "../components/ManageUsers";
import UserLog from "../components/UserLog";
import { hasAccess } from "../functions";
import { prodApi } from "../data/api";

const usersUrl = `${prodApi.data}/users`;
const logUrl = prodApi.log;

const AdminUserMgt = ({ maxWidth }) => {
  const [usersData, setUsersData] = useState([]);
  const [logData, setLogData] = useState([]);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const { loggedIn, isLoggedIn } = useContext(AuthContext);

  const fetchData = async (url, setData) => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        setError("Authorization token is missing.");
        return;
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Process and store the users' logData
      setData(response.data);
    } catch (error) {
      console.error("Error fetching users data:", error);
      const message =
        error.response && error.response.status === 403
          ? "You do not have the necessary permissions."
          : "Failed to fetch user data. Please try again later.";
      setError(message);
    }
  };

  useEffect(() => {
    fetchData(usersUrl, setUsersData);
  }, []);

  useEffect(() => {
    fetchData(logUrl, setLogData);
  }, []);

  return (
    <>
      {loggedIn && hasAccess(isLoggedIn.accessLevel, ["admin", "omni"]) && (
        <Box sx={{ position: "relative" }}>
          <Box
            sx={{
              minHeight: "110dvh",
              width: "90%",
              maxWidth: maxWidth,
              zIndex: 0,
              m: "auto",
              p: "auto",
            }}
          >
            <Box
              sx={{
                mt: 9,
                fontSize: "2rem",
                fontWeight: "200",
              }}
            >
              Administration
            </Box>
            <Box
              sx={{
                mb: 1.5,
                fontSize: "1.25rem",
                fontWeight: "200",
              }}
            >
              User Management
            </Box>
            <Box sx={{ mt: "2rem" }}>
              <ManageUsers
                header="Manage Users"
                data={usersData}
                setData={setUsersData}
                adminId={isLoggedIn.uniqueId}
              />
            </Box>
            <Box sx={{ mt: "2rem" }}>
              <UserLog
                header="User Log"
                data={logData}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                itemsPerPage={25}
              />
            </Box>
            <Box sx={{ height: "10dvh" }} />
          </Box>
        </Box>
      )}
    </>
  );
};

export default AdminUserMgt;
